import React, { Component } from "react";

import { connect } from "react-redux";
import { Card, CardBody, CardGroup, Col, Container, Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { login, tryLogin } from "../../actions/baseActions";
import LoginForm from "../../components/Forms/LoginForm";

class Login extends Component {
  componentDidMount() {
    localStorage.clear();
    this.props.tryLogin(false);
  }

  render() {
    const { login } = this.props;

    let bg = "bgLogin";
    if (
      [
        "ava.livros.homologa.educandus.net",
        "ava.livros.educandus.net"
      ].includes(window.location.host.toLowerCase())
    ) {
      bg = "bgLivros";
    } else if (
      [
        "ava.avaliacao.homologa.educandus.net",
        "ava.avaliacao.educandus.net"
      ].includes(window.location.host.toLowerCase())
    ) {
      bg = "bgAvaliacao";
    }

    return (
      <div className={`app flex-row align-items-center overflow-hidden ${bg}`}>
        <Container>
          <Row className="justify-content-end">
            <Col md="5" className="fadeLogin">
              <CardGroup>
                <Card className="p-4 loginCardClean">
                  <CardBody>
                    <LoginForm
                      onSubmit={login}
                      loading={this.props.general.tryLogin}
                    />
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({ general: state.general });

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      login,
      tryLogin
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
